// React
import React from "react";
// React
// CSS
import styles from "./FullQuizCreatorCard.module.css";
// CSS
// Models
import { I_FullQuizItem } from "../../../../Models/interfaces";
// Models

type FullQuizCreatorCardProps = {
  data: I_FullQuizItem;
  setIsModalInScreen: React.Dispatch<React.SetStateAction<boolean>>;
  setModalData: React.Dispatch<
    React.SetStateAction<I_FullQuizItem | undefined>
  >;
};

const FullQuizCreatorCard: React.FunctionComponent<
  FullQuizCreatorCardProps
> = ({
  data: {
    is_locked,
    early_price,
    gift_price,
    quiz_time,
    shamsi_quiz_date,
    title,
    id,
    price,
    has_paid,
    award,
    grade,
    grade_id,
    grade_name,
    quiz_date,
    answer_file,
  },
  setIsModalInScreen,
  setModalData,
}) => {
  return (
    <div
      className={`${styles.fullQuizItem} flex flex-row items-center justify-between w-full mt-3 pb-3 cursor-pointer`}
      onClick={() => {
        setModalData({
          is_locked,
          early_price,
          gift_price,
          quiz_time,
          shamsi_quiz_date,
          title,
          id,
          price,
          has_paid,
          award,
          grade,
          grade_id,
          grade_name,
          quiz_date,
          answer_file,
        });
        setIsModalInScreen(true);
      }}
    >
      <div className={`${styles.left} flex flex-col items-start`}>
        {has_paid ? (
          <span className="text-gray-400 text-xs">خریداری شده</span>
        ) : (
          <>
            <p
              className="text-sm font-bold"
              style={{ color: `rgb(0 , 150 ,136)` }}
            >
              {is_locked ? early_price : Number(gift_price + price)}
            </p>
            <p
              className="mt-2"
              style={{ color: `rgb(0 , 150 ,136)`, fontSize: "10px" }}
            >
              {is_locked ? "تومان(پیش گشایش)" : "تومان (کیف پول هدیه)"}
            </p>
          </>
        )}
      </div>
      <div className={`${styles.right} flex flex-col items-end min-w-max`}>
        <p className="text-base font-bold">{title}</p>
        <p className="flex flex-row items-center mt-2">
          <span className="text-xs">
            <span>انتشار : </span>
            <span>{shamsi_quiz_date}</span>
          </span>
          <span className="text-xs">
            <span>مدت زمان آزمون :</span>
            <span>{quiz_time} دقیقه</span>
          </span>
        </p>
      </div>
    </div>
  );
};

export default FullQuizCreatorCard;
